import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { getImageFile, fallbackImage } from 'utils/stringUtils';
import { Link } from 'react-router-dom';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import withSizes from 'react-sizes';
import Mixpanel from 'utils/mixpanelService';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import DateAndOrgs from './DateAndOrgs';

const styles = theme => ({
  link: {
    textDecoration: 'none',
    width: '100%',
  },
  cardRoot: {
    cursor: 'pointer',
    position: 'relative',
    marginBottom: 20,
    height: 106,
    [theme.breakpoints.down('480')]: {
      marginBottom: 0,
    },
  },
  imageWrapper: {
    display: 'block',
    width: '100%',
    height: 'auto',
    position: 'relative',
    overflow: 'hidden',
  },
  image: {
    display: 'block',
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
  infoWrapper: {
    paddingLeft: 30,
    '@media (min-width:600px) and (max-width:991px)': {
      // eslint-disable-line no-useless-computed-key
      paddingLeft: 0,
    },
    [theme.breakpoints.down('480')]: {
      paddingLeft: 0,
    },
  },
  name: {
    display: '-webkit-box',
    margin: '0 auto',
    '-webkit-line-clamp': '2',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    height: 40 /* Fallback for non-webkit */,
  },
  label: {
    ...theme.typography.pxSmall,
  },
});

function SmallNewsCard(props) {
  const { data, classes, isMobile, isTablet } = props;
  const {
    fields,
    fields: { slug, name, topics = [] },
  } = data;
  const file = getImageFile(fields);

  const redirect = () => {
    const {
      fields: { blog },
    } = data;
    const pageName = window.location.pathname.split('/')[1];
    const finalPageName = pageName ? `${pageName}Page` : 'homePage';
    Mixpanel.track('Resource Card - Clicked', {
      name,
      type: 'article',
      subtype: 'News',
      blog,
      page: finalPageName,
      path: window.location.pathname.split('/')[1],
      slug: window.location.pathname.split('/')[2],
    });
  };

  return (
    <Link to={`/articles/${slug}`} onClick={redirect} className={classes.link}>
      <Grid container direction="row" className={classes.cardRoot}>
        {isMobile || isTablet ? (
          ''
        ) : (
          <Grid item xs={4} className={classes.imageWrapper}>
            <LazyLoadImage
              src={file}
              data-src={file}
              alt="News"
              onError={e => {
                e.target.src = fallbackImage;
              }}
              width="100%"
              height="100%"
              className={classes.image}
            />
          </Grid>
        )}

        <Grid item xs={isMobile || isTablet ? 12 : 8}>
          <Grid container direction="row" className={classes.infoWrapper}>
            <Grid item xs={12}>
              {_isEmpty(topics) && _isEmpty(_get(topics, '0.fields')) ? (
                <Typography className={classes.label} color="textSecondary">
                  News
                </Typography>
              ) : (
                <Link
                  to={`/topics/${topics[0].fields.slug}`}
                  className={classes.link}
                >
                  <Typography className={classes.label} color="textSecondary">
                    {topics[0].fields.title}
                  </Typography>
                </Link>
              )}
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant="h6"
                color="textPrimary"
                className={classes.name}
              >
                {name}
              </Typography>
            </Grid>
            <DateAndOrgs data={data} />
          </Grid>
        </Grid>
      </Grid>
    </Link>
  );
}
SmallNewsCard.propTypes = {
  data: PropTypes.object,
  classes: PropTypes.object,
  isMobile: PropTypes.bool,
  isTablet: PropTypes.bool,
};

const mapSizesToProps = ({ width }) => ({
  isMobile: width <= 480,
  isTablet: width >= 600 && width <= 991,
});

export default compose(
  withSizes(mapSizesToProps),
  withStyles(styles),
)(SmallNewsCard);
